import { DFY_ADD_ON_CREDITS } from "@repo/api/utils/dfy-billing";
import { useDfyOrderStore } from "@/lib/stores/dfy-order-store/dfy-order-store";
import {
  DFY_ADD_ON_CONTENT,
  formatDfyCreditsToPrice,
} from "../dfy-order-form-content";
import { DfyStepProps } from "../dfy-order-form-steps";
import OptionCard from "../components/OptionCard";
import DfyStepHeader from "../components/DfyStepHeader";
import DfyStepNavigation from "../components/DfyStepNavigation";

export default function AddOnsStep({ onBack, onNext }: DfyStepProps) {
  const addOns = useDfyOrderStore((state) => state.order?.details.addOns);
  const toggleAddOn = useDfyOrderStore((state) => state.service.toggleAddOn);

  if (!addOns) {
    return null;
  }

  return (
    <>
      <DfyStepHeader
        title="Add-ons"
        description="Optional extras for your package."
      />
      <div className="flex flex-col gap-8 py-6">
        <div className="flex flex-col gap-4">
          {DFY_ADD_ON_CONTENT.map((option) => {
            const credits = DFY_ADD_ON_CREDITS[option.id];
            return (
              <OptionCard
                key={option.id}
                option={option}
                price={
                  credits > 0 ? `+${formatDfyCreditsToPrice(credits)}` : "Free"
                }
                isSelected={addOns[option.id]}
                onToggle={() => toggleAddOn(option.id)}
              />
            );
          })}
        </div>
        <DfyStepNavigation onBack={onBack} onNext={onNext} />
      </div>
    </>
  );
}
